@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@gap: 12px;
@column: calc(50% - calc(@gap / 2));

.header {
  display: grid;
  grid-template-columns: @column @column;
  gap: @gap @gap;
  padding: 0 @gap @gap;
  border-bottom: 1px solid var(--gray-DFE4E8);
  margin-bottom: @gap;
}
